const PLAYER_STATE_STATUSES = {
  AUTOSTART_NOT_ALLOWED: 'AUTOSTART_NOT_ALLOWED',
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  PLAYING: 'PLAYING',
  PAUSED: 'PAUSED',
  BUFFERING: 'BUFFERING',
  RESUMING_FROM_BUFFERING: 'RESUMING_FROM_BUFFERING',
  SEEKING: 'SEEKING',
  STOPPED: 'STOPPED',
  ENDED: 'ENDED',
  ERROR: 'ERROR',
};

const PLAYER_CONTENT_KIND = {
  LINEAR_CHANNEL: 'linearChannel',
  VOD: 'VOD',
  VIRAL: 'viral',
};

const CCSETTINGSMENU = [
  { nameKey: 'reset', value: 'reset' },
  {
    nameKey: 'font_family',
    list: [
      { name: 'Typewriter', value: 'Courier new, Courier, monospace' },
      { name: 'Serif', value: '"Times New Roman", Times, serif' },
      { name: 'Block', value: 'Helvetica Monospaced, sans-serif' },
      { name: 'Sans Serif', value: 'Arial, Swiss, sans-serif' },
      { name: 'Casual', value: 'Dom, Impress, sans-serif' },
      { name: 'Cursive', value: 'Coronet, Marigold, cursive' },
      { name: 'Small Capitals', value: '"Engravers Gothic", serif, sans-serif' },
    ],
  },

  {
    nameKey: 'font_size',
    list: [
      { name: '400%', value: 20 * 4 },
      { name: '200%', value: 20 * 2 },
      { name: '150%', value: 20 * 1.5 },
      { name: '100%', value: 20 },
      { name: '75%', value: 20 * 0.75 },
      { name: '50%', value: 20 * 0.5 },
    ],
  },
  {
    nameKey: 'color',
    list: [
      { nameKey: 'white', value: '#FFF' },
      { nameKey: 'black', value: '#000' },
      { nameKey: 'red', value: '#ff0000' },
      { nameKey: 'blue', value: '#0095ff' },
      { nameKey: 'yellow', value: '#ffeb00' },
      { nameKey: 'green', value: '#008000' },
      { nameKey: 'magenta', value: '#ff00ff' },
      { nameKey: 'cyan', value: '#00ffff' },
    ],
  },
  {
    nameKey: 'font_opacity',
    list: [
      { name: '100%', value: 100 },
      { name: '75%', value: 75 },
      { name: '50%', value: 50 },
      { name: '25%', value: 25 },
      { name: '0%', value: 0 },
    ],
  },
  {
    nameKey: 'background_color',
    list: [
      { nameKey: 'white', value: '#FFF' },
      { nameKey: 'black', value: '#000' },
      { nameKey: 'red', value: '#ff0000' },
      { nameKey: 'blue', value: '#0095ff' },
      { nameKey: 'yellow', value: '#ffeb00' },
      { nameKey: 'green', value: '#008000' },
      { nameKey: 'magenta', value: '#ff00ff' },
      { nameKey: 'cyan', value: '#00ffff' },
    ],
  },
  {
    nameKey: 'background_opacity',
    list: [
      { name: '100%', value: 100 },
      { name: '75%', value: 75 },
      { name: '50%', value: 50 },
      { name: '25%', value: 25 },
      { name: '0%', value: 0 },
    ],
  },
  {
    nameKey: 'text_shadow',
    list: [
      { name: 'No Edge', value: 'none' },
      { name: 'Raised', value: '3px 0 0' },
      { name: 'Depressed', value: '0 0 3px' },
      { name: 'Uniform', value: '0 0 2px' },
      { name: 'Drop Shadow', value: '3px 3px 0' },
    ],
  },
  {
    nameKey: 'text_shadow_color',
    list: [
      { nameKey: 'white', value: '#FFF' },
      { nameKey: 'black', value: '#000' },
      { nameKey: 'red', value: '#ff0000' },
      { nameKey: 'blue', value: '#0095ff' },
      { nameKey: 'yellow', value: '#ffeb00' },
      { nameKey: 'green', value: '#008000' },
      { nameKey: 'magenta', value: '#ff00ff' },
      { nameKey: 'cyan', value: '#00ffff' },
    ],
  },
  {
    nameKey: 'text_shadow_opacity',
    list: [
      { name: '100%', value: 100 },
      { name: '75%', value: 75 },
      { name: '50%', value: 50 },
      { name: '25%', value: 25 },
      { name: '0%', value: 0 },
    ],
  },
  {
    nameKey: 'window_background_color',
    list: [
      { nameKey: 'white', value: '#FFF' },
      { nameKey: 'black', value: '#000' },
      { nameKey: 'red', value: '#ff0000' },
      { nameKey: 'blue', value: '#0095ff' },
      { nameKey: 'yellow', value: '#ffeb00' },
      { nameKey: 'green', value: '#008000' },
      { nameKey: 'magenta', value: '#ff00ff' },
      { nameKey: 'cyan', value: '#00ffff' },
    ],
  },
  {
    nameKey: 'window_background_opacity',
    list: [
      { name: '100%', value: 100 },
      { name: '75%', value: 75 },
      { name: '50%', value: 50 },
      { name: '25%', value: 25 },
      { name: '0%', value: 0 },
    ],
  },
];

const PLAYER_LAST_CONTENT_LOCAL_STORAGE_KEY = 'ptv-last-content';

export { PLAYER_STATE_STATUSES, PLAYER_CONTENT_KIND, CCSETTINGSMENU, PLAYER_LAST_CONTENT_LOCAL_STORAGE_KEY };
